import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const fetchSimilarSteps = async ({ testStepId, testSuiteId, ...filterParams }) => {
  const user = getUserDetails();

  const params = new URLSearchParams({
    action: "getSimilarSteps",
    companyId: user.companyid,
    testStepId,
    testSuiteId,
  });

  Object.keys(filterParams).forEach((key) => {
    const value = filterParams[key];
    if (value === undefined || value === null) return;
    params.set(key, value);
  });

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${params.toString()}`,
  );

  return response.data;
};

const useGetSimilarStepsQuery = (params, options = {}) => {
  const { testStepId, testSuiteId, ...filterParams } = params;
  const filterSignature = JSON.stringify(
    Object.entries(filterParams)
      .filter(([, value]) => value !== undefined && value !== null)
      .sort(([a], [b]) => a.localeCompare(b)),
  );

  return useQuery({
    queryKey: ["similarSteps", testStepId, testSuiteId, filterSignature],
    queryFn: () => fetchSimilarSteps(params),
    enabled: options.enabled !== undefined ? options.enabled : !!testStepId && !!testSuiteId,
    retry: false,
  });
};

export default useGetSimilarStepsQuery;
